export default __webpack_public_path__ + "static/media/etapa3.f229c00f.png";